import { renderCMSComponent } from "~/features/cms/componentFactory";
import type { CMSComponentProps } from "~/features/cms/types/props";

/**
 * JSP Bridge: Creates a CMS component from a JSON string.
 * Used by componentRegistry to mount React CMS components into JSP pages.
 */
export const createCMSComponent = (json: string) => {
  if (!json || !json.length) {
    if (import.meta.env.DEV) {
      console.warn(`CMSComponent json string is invalid`, json);
    }
    return;
  }

  const props: CMSComponentProps = JSON.parse(json);
  const element = renderCMSComponent(props);
  if (!element) {
    console.error(`Could not create a CMS component for type ${props.type}`);
    return null;
  }
  return element;
};
